if (!customElements.get("media-gallery")) {
  customElements.define(
    "media-gallery",
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          // Fallback to class if ID is not present
          liveRegion:
            this.querySelector('[id^="GalleryStatus"]') ||
            this.querySelector(".visually-hidden"),
          viewer:
            this.querySelector('[id^="GalleryViewer"]') ||
            this.querySelector(".product-media-swiper"),
          thumbnails:
            this.querySelector('[id^="GalleryThumbnails"]') ||
            this.querySelector(".product-media-thumb-swiper"),
        };

        this.mql = window.matchMedia("(min-width: 750px)");

        // CRITICAL FIX: Check if elements exist before proceeding to prevent the "null" error
        if (!this.elements.viewer || !this.elements.thumbnails) {
          console.warn("MediaGallery: Viewer or Thumbnails element not found.");
          return;
        }

        // Safely attach event listener
        this.elements.viewer.addEventListener(
          "slideChanged",
          debounce(this.onSlideChanged.bind(this), 500),
        );

        // Setup thumbnail clicks
        this.elements.thumbnails
          .querySelectorAll("[data-target]")
          .forEach((mediaToSwitch) => {
            const btn = mediaToSwitch.querySelector("button");
            if (btn) {
              btn.addEventListener(
                "click",
                this.setActiveMedia.bind(
                  this,
                  mediaToSwitch.dataset.target,
                  false,
                ),
              );
            }
          });

        // Use optional chaining for dataset to prevent errors if dataset is undefined
        if (
          this.dataset?.desktopLayout?.includes("thumbnail") &&
          this.mql.matches
        ) {
          this.removeListSemantic();
        }
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`,
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        // Use the mediaId passed from the variant change or click
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector("[data-media-id]");

        if (!activeMedia) {
          console.warn(`MediaGallery: No media found with ID ${mediaId}`);
          return;
        }

        this.elements.viewer
          .querySelectorAll("[data-media-id]")
          .forEach((element) => {
            element.classList.remove("is-active");
          });
        activeMedia.classList.add("is-active");

        if (prepend) {
          if (activeMedia.parentElement.firstChild !== activeMedia) {
            activeMedia.parentElement.prepend(activeMedia);
          }

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(
              `[data-target="${mediaId}"]`,
            );
            if (
              activeThumbnail &&
              activeThumbnail.parentElement.firstChild !== activeThumbnail
            ) {
              activeThumbnail.parentElement.prepend(activeThumbnail);
            }
          }

          // Check if slider exists before calling reset
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();

        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({
              left: activeMedia.offsetLeft,
            });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          // window.scrollTo({ top: top, behavior: "smooth" });
        });

        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${mediaId}"]`,
        );
        this.setActiveThumbnail(activeThumbnail);

        if (activeThumbnail) {
          this.announceLiveRegion(
            activeMedia,
            activeThumbnail.dataset.mediaPosition,
          );
        }
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll("button")
          .forEach((element) => element.removeAttribute("aria-current"));

        const btn = thumbnail.querySelector("button");
        if (btn) btn.setAttribute("aria-current", "true");

        // Check if the slider object exists (Swiper integration)
        if (
          this.elements.thumbnails.slider &&
          !this.elements.thumbnails.isSlideVisible(thumbnail, 10)
        ) {
          this.elements.thumbnails.slider.scrollTo({
            left: thumbnail.offsetLeft,
          });
        }
      }

      announceLiveRegion(activeItem, position) {
        // Ensure liveRegion exists
        if (!this.elements.liveRegion) return;

        const image = activeItem.querySelector("img");
        if (!image) return;

        image.onload = () => {
          this.elements.liveRegion.setAttribute("aria-hidden", false);
          // Use a fallback string if accessibilityStrings is not loaded
          const text =
            window.accessibilityStrings &&
            window.accessibilityStrings.imageAvailable
              ? window.accessibilityStrings.imageAvailable.replace(
                  "[index]",
                  position,
                )
              : `Image ${position} available`;

          this.elements.liveRegion.innerHTML = text;
          setTimeout(() => {
            this.elements.liveRegion.setAttribute("aria-hidden", true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        // Safely call pauseAllMedia if it exists
        if (typeof window.pauseAllMedia === "function") {
          window.pauseAllMedia();
        }
        const deferredMedia = activeItem.querySelector(".deferred-media");
        if (deferredMedia && typeof deferredMedia.loadContent === "function") {
          deferredMedia.loadContent(false);
        }
      }

      preventStickyHeader() {
        this.stickyHeader =
          this.stickyHeader || document.querySelector("sticky-header");
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event("preventHeaderReveal"));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute("role", "presentation");
        this.elements.viewer.sliderItems.forEach((slide) =>
          slide.setAttribute("role", "presentation"),
        );
      }
    },
  );
}
